import {get, post} from '@/utils/request'

const upstreamApi = {
  /* 用户管理-上游供货商获取所有（在需要选择上游供货商的地方可以使用，比如上游流控设置里面选择上游供货商的） */
  getAllUpstream: function () {
    return get('/member/upstream/list-all', {})
  },
  /* 高级配置-上游流控配置-添加或编辑（如果是编辑则需要传ID参数） */
  saveForm: function (params) {
    return post('/advanced/config/upstream/save-update', {
      id: params.id,
      upstreamMemberId: params.upstreamMemberId,
      totalLimit: params.totalLimit,
      mobileLimit: params.mobileLimit,
      telecomLimit: params.telecomLimit,
      unicomLimit: params.unicomLimit,
      secondLimit: params.secondLimit,
      phoneFailedLimit: params.phoneFailedLimit
    })
  },
  /* 高级配置-上游流控配置-添加或编辑初始化（如果是编辑则需要传ID参数，会根据ID返回相应信息, 如果是添加操作也可以不请求该接口方法。查看信息也可以使用该接口方法） */
  getInit: function (id) {
    return get('/advanced/config/upstream/save-update-init', {
      id
    }
    )
  }
}

export default upstreamApi



// WEBPACK FOOTER //
// ./src/api/upstreamApi.js